import Vue from 'vue';
import '@/helpers/global';
import { eventBus } from '@/helpers/eventBus';
import { i18n, loadLanguageAsync } from '@/lang';
import App from './App.vue';
import createRouter from './router';
import store from './store';

import { bindNativeEvents } from '@/app/_APP';
import { bindWindowEvents } from '@/app/window';
import Native from '@/app/native';
import 'clientjs';

import '@/scss/style.scss';

Vue.config.productionTip = false;
Vue.prototype.$eventBus = eventBus;

function getDeviceInfo () {
  // eslint-disable-next-line no-undef
  var client = new ClientJS();

  const deviceInfo = {
    deviceid: client.getFingerprint(),
    os: client.getOS().toLowerCase(),
    osversion: client.getOSVersion(),
    app: client.getBrowser().toLowerCase(),
    appversion: client.getBrowserVersion()
  };

  if (!deviceInfo.os) {
    deviceInfo.os = 'unknown';
  } else if (deviceInfo.os.trim() === '') {
    deviceInfo.os = 'unknown';
  }

  return deviceInfo;
};

function fetchLocalLanguage (defaultLang) {
  const lang = localStorage.getItem('SITE_LANGUAGE') || defaultLang;
  loadLanguageAsync(lang);
}

async function initVue () {
  const fetchedConfig = window.$CONFIG || {
    conf: {},
    INTERNATIONALIZATION: {},
    EM_LOGOS: {},
    LANGUAGES: []
  };
  const router = createRouter(`${window.$CONFIG.conf.appconfig.app_version}/${window.$CONFIG.conf.appconfig.app_key}`);
  delete window.$CONFIG;
  if (
    fetchedConfig &&
    fetchedConfig.conf &&
    fetchedConfig.INTERNATIONALIZATION &&
    fetchedConfig.EM_LOGOS &&
    fetchedConfig.LANGUAGES
  ) {
    /**
     * comment out on development
     */

    i18n.setLocaleMessage(
      fetchedConfig.EM_MY_LANG,
      fetchedConfig.INTERNATIONALIZATION
    );

    i18n.locale = fetchedConfig.EM_MY_LANG;

    window.$_APP = bindNativeEvents(eventBus);
    bindWindowEvents(window, eventBus);
    Vue.prototype.$eventBus = eventBus;

    if (!fetchedConfig.EM_LOGOS.DEFAULT_USER_IMAGE) {
      fetchedConfig.EM_LOGOS.DEFAULT_USER_IMAGE = 'user.jpg';
    }
    if (!fetchedConfig.EM_LOGOS.DEFAULT_CONTACT_IMAGE) {
      fetchedConfig.EM_LOGOS.DEFAULT_CONTACT_IMAGE = 'user.jpg';
    }
    if (!fetchedConfig.EM_LOGOS.DEFAULT_DIAL_IMAGE) {
      fetchedConfig.EM_LOGOS.DEFAULT_DIAL_IMAGE = 'dial-blue.jpg';
    }
    Vue.prototype.$_LOGOS = fetchedConfig.EM_LOGOS;
    Vue.prototype.$_NATIVE = Native;

    fetchedConfig.conf.languages = fetchedConfig.LANGUAGES;

    const devInfo = getDeviceInfo();

    await store.dispatch('AppStore/setDeviceInfo', devInfo, {
      root: true
    });

    await store.dispatch('AppStore/setConfig', fetchedConfig.conf, {
      root: true
    });
  }

  fetchLocalLanguage(i18n.locale);

  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app');
}

initVue();
